"use client";
// components/CardImage.tsx
import { useEffect, useState } from "react";
import { Box, CardMedia, Skeleton, SxProps, Theme } from "@mui/material";
import { AddPhotoAlternateOutlined } from "@mui/icons-material";

// props 타입 정의
interface CardImageProps {
  height?:
    | number
    | string
    | {
        xs?: number | string;
        sm?: number | string;
        md?: number | string;
        lg?: number | string;
        xl?: number | string;
      };
  imagePath: string | File; // 경로 또는 파일 객체를 받도록 수정
}
function CardImage({ height, imagePath }: CardImageProps) {
  const resolvedHeight = height ?? "auto";
  const iconSize = typeof resolvedHeight === "number" ? resolvedHeight / 2 : 100; // fallback size
  if (!imagePath) {
    return (
      <Box
        sx={{
          position: "relative",
          width: "100%",
          aspectRatio: "16/9",
          height: resolvedHeight,
          borderRadius: {
            xs: 0,
            sm: "4px",
            md: "4px",
            lg: "8px",
            xl: "8px",
          },
          overflow: "hidden",
        }}
      >
        <Skeleton
          variant="rectangular"
          animation={"wave"}
          sx={{
            width: "100%",
            height: "100%",
          }}
        />
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            color: "rgba(0, 0, 0, 0.3)",
          }}
        >
          <AddPhotoAlternateOutlined sx={{ fontSize: iconSize }} />
        </Box>
      </Box>
    );
  }

  return (
    <CardMedia
      component="img"
      image={imagePath instanceof File ? URL.createObjectURL(imagePath) : imagePath}
      alt="thumbnail"
      loading="eager"
      fetchPriority="high"
      sx={{
        height: resolvedHeight,
        objectFit: "cover",
        aspectRatio: "16/9",
        width: "100%",
        // 추가된 스타일
        opacity: 0, // 초기 투명도
        transition: "opacity 0.6s ease-in-out", // 부드러운 페이드 인 효과
        "&.MuiCardMedia-img": {
          opacity: 1, // 이미지 로드 후 투명도
        },
        borderRadius: {
          xs: 0,
          sm: "4px",
          md: "4px",
          lg: "8px",
          xl: "8px",
        },
      }}
    />
  );
}

export default CardImage;
